import { PropsWithChildren } from 'react';
import BaseLayout from './BaseLayout';

const MainLayout = ({ children }: PropsWithChildren<{}>) => (
  <BaseLayout>{children}</BaseLayout>
);

export default MainLayout;
